// ======================================================================
// File Name       : FormUtils
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export function onChangeWrapper(onChange, realValue) {
  return (event) => {
    const { name, value } = event.target;
    // Because event.target.value always return a string
    // Rely on rendered data, parse coressponding data type
    const convertedValue = Number.isInteger(realValue) ? parseInt(value, 10) : value;
    return onChange && onChange(name, convertedValue);
  };
}
